import classNames from 'classnames';
import * as React from 'react';
import { Text } from 'vet-bones/components';

import { Link } from 'src/components/Link';
import {
  PROJECT_DIAGRAM_ENTITY_DRAWER_RELATIONSHIP_TYPE,
  getProjectDiagramEntityDrawerTableLinkTestId,
  getProjectDiagramEntityDrawerTableRowTestId,
} from 'src/constants/testIds';
import { ProjectDiagramClassDrawerRelationshipsDirections } from 'src/containers/ProjectDiagram/components/classDrawer/ProjectDiagramClassDrawerRelationshipsDirections';
import { ClassRelationshipItem } from 'src/containers/ProjectDiagram/components/classDrawer/types';
import {
  EditButton,
  EntityDrawerButtonType,
  UnlinkButton,
} from 'src/containers/ProjectDiagram/components/ProjectDiagramEntityDrawerButtons';

type ProjectDiagramClassDrawerRelationshipsRowProps = {
  idx: number;
  isPreviousRowHighlighted?: boolean;
  relationship: ClassRelationshipItem & { depth?: number };
  onClickEdit: (item: ClassRelationshipItem) => void;
  onClickLink?: (item: ClassRelationshipItem) => void;
  onUnlink: (item: ClassRelationshipItem) => void;
};

export const ProjectDiagramClassDrawerRelationshipsRow: React.VFC<
  ProjectDiagramClassDrawerRelationshipsRowProps
> = ({
  idx,
  isPreviousRowHighlighted,
  relationship,
  onClickEdit,
  onClickLink,
  onUnlink,
}) => {
  return (
    <tr
      className={classNames('sd-has-hidden-until-hover', {
        'sd-highlighted-table-row': relationship.highlighted,
        'sd-highlighted-table-row__no-top-border':
          relationship.highlighted && isPreviousRowHighlighted,
      })}
      data-testid={getProjectDiagramEntityDrawerTableRowTestId(
        relationship.value,
        PROJECT_DIAGRAM_ENTITY_DRAWER_RELATIONSHIP_TYPE,
        idx
      )}
    >
      <td>
        {onClickLink ? (
          <Link
            className="sd-drawer-project-diagram-entity-table-standin--input"
            onClick={() => onClickLink(relationship)}
            testId={getProjectDiagramEntityDrawerTableLinkTestId(
              relationship.value,
              PROJECT_DIAGRAM_ENTITY_DRAWER_RELATIONSHIP_TYPE,
              idx
            )}
          >
            <Text ellipsize>{relationship.text}</Text>
          </Link>
        ) : (
          <Text
            className="sd-drawer-project-diagram-entity-table-standin--input"
            ellipsize
          >
            {relationship.text}
          </Text>
        )}
      </td>
      <td>
        <ProjectDiagramClassDrawerRelationshipsDirections
          directions={relationship.directions}
        />
      </td>
      <td>
        <EditButton
          disabled={(relationship.depth ?? 0) > 1}
          onClick={() => onClickEdit(relationship)}
          type={EntityDrawerButtonType.RELATIONSHIP}
        />
        <UnlinkButton
          disabled={(relationship.depth ?? 0) > 1}
          onClick={() => onUnlink(relationship)}
          type={EntityDrawerButtonType.RELATIONSHIP}
        />
      </td>
    </tr>
  );
};
